/*
 * Erreke — añadir al carrito con fetch y drawer (tarjetas de colección y ficha).
 *
 * Por qué existe. El envío clásico de formulario a /cart/add recargaba la
 * página, el drawer no se abría nunca y Klaviyo no recibía «Added to Cart»
 * (su script escucha las llamadas fetch a /cart/add).
 *
 * 28 ago 26 — DOS ARREGLOS TRAS DEPURAR EN LA TIENDA REAL:
 *
 * 1. En esta tienda, los POST a /cart/add devuelven SIEMPRE «sections: null»
 *    (el cart transform de Simple Bundles rompe el render de secciones del
 *    POST; el render por GET sí funciona). El producto SÍ se añadía, pero
 *    renderContents reventaba con el null, caía al catch y este reenviaba el
 *    formulario: el drawer nunca se abría y CADA CLIC AÑADÍA EL PRODUCTO DOS
 *    VECES. Ahora, si el POST no trae las secciones, se piden aparte con un
 *    GET a /?sections=… y el drawer se abre igual.
 *
 * 2. El reenvío nativo del formulario queda SOLO para cuando el producto no
 *    se ha llegado a añadir (dependencias sin cargar o fallo de red antes del
 *    alta). Si el añadido ya está hecho y lo que falla es pintar el drawer,
 *    se navega al carrito: nunca un segundo añadido.
 */
if (!customElements.get('erreke-add')) {
  customElements.define(
    'erreke-add',
    class ErrekeAdd extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.submitButton = this.querySelector('[type="submit"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        if (this.cart && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmit(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Mismo seguro que en product-form.js: sin dependencias, envío nativo.
        // Aquí todavía no se ha añadido nada, así que no duplica.
        if (typeof fetchConfig !== 'function' || typeof routes === 'undefined') {
          HTMLFormElement.prototype.submit.call(this.form);
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('is-cargando');
        this.textoOriginal = this.submitButton.textContent;
        if (this.dataset.textoCargando) this.submitButton.textContent = this.dataset.textoCargando;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((s) => s.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((r) => r.json())
          .then(async (response) => {
            if (response.status) {
              // Agotado o sin stock suficiente: no se ha añadido nada.
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'erreke-parrilla',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.submitButton.textContent = this.dataset.textoError || this.textoOriginal;
              return;
            }

            // A partir de aquí el producto YA está en el carrito: pase lo que
            // pase, nunca reenviar el formulario (lo añadiría otra vez).
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            try {
              const pendientes = this.cart.getSectionsToRender().some((s) => !response.sections || !response.sections[s.id]);
              if (pendientes) {
                // Simple Bundles anula las secciones del POST: se piden aparte.
                const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
                const ids = this.cart.getSectionsToRender().map((s) => s.id).join(',');
                const res = await fetch(raiz + '?sections=' + ids);
                response.sections = await res.json();
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'erreke-parrilla',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }
              this.cart.renderContents(response);
            } catch (e) {
              console.error(e);
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => {
            // Fallo de red antes del alta: el envío nativo salva el pedido.
            console.error(e);
            HTMLFormElement.prototype.submit.call(this.form);
          })
          .finally(() => {
            this.submitButton.classList.remove('is-cargando');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.textoOriginal) this.submitButton.textContent = this.textoOriginal;
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }
    }
  );
}
